/* 该服务旨在根据后端消息类型jar包的配置，动态控制哪些消息类型或者消息类型的信息需要显示 */

import { Injectable } from '@angular/core';
import { ACLService } from '@delon/acl';
import { _HttpClient } from '@delon/theme';
import { deepCopy } from '@delon/util';
import { URLS } from '../constant/interface';
import { PATCHTYPES, _MSGTYPES } from '../constant/msgType';
import { REPORT } from '../constant/report';
import { Subject } from 'rxjs';

interface MsgItem {
  type: number;
  name: string;
  key: string;
};

@Injectable({
  providedIn: 'root'
})
export class MsgPluginFilterService {

  constructor(public http: _HttpClient, private aclService: ACLService) { }
  /* 后台插件化获取的消息类型 */
  private MSGPLUGINS:any;


  private $request: Subject<any>;


  /* 单消息类型与报表id的匹配规则 */
  private matchRules = [{
    msgType: _MSGTYPES.MT.SMS.type,
    reports: [REPORT.TREND_SEND.id, REPORT.TOTAL_BIZTYPE_SEND.id, REPORT.TREND_SMS_SEND.id]
  },{
    msgType: _MSGTYPES.MT.WECHAT.type,
    reports: [REPORT.TREND_SEND.id, REPORT.TOTAL_BIZTYPE_SEND.id, REPORT.TOTAL_WECHAT_FANS.id, REPORT.TREND_WECHAT_INDICATOR.id]
  }, {
    msgType: _MSGTYPES.MT.EMAIL.type,
    reports: [REPORT.TREND_SEND.id, REPORT.TOTAL_BIZTYPE_SEND.id, REPORT.TREND_EMAIL_SEND.id]
  }, {
    msgType: _MSGTYPES.MT.VOICE.type,
    reports: [REPORT.TREND_SEND.id, REPORT.TOTAL_BIZTYPE_SEND.id, REPORT.TREND_VOICE_TIME.id, REPORT.FUNNEL_VOICE_SEND.id]
  }, {
    msgType: _MSGTYPES.MT.JPUSH.type,
    reports: [REPORT.TREND_SEND.id, REPORT.TOTAL_BIZTYPE_SEND.id]
  }, {
    msgType: _MSGTYPES.MT._5G.type,
    reports: [REPORT.TREND_SEND.id, REPORT.TOTAL_BIZTYPE_SEND.id]
  }, {
    msgType: _MSGTYPES.MT.TIKTOK.type,
    reports: [REPORT.TREND_SEND.id, REPORT.TOTAL_BIZTYPE_SEND.id]
  }, {
    msgType: _MSGTYPES.MT.WORKWX.type,
    reports: [REPORT.TREND_SEND.id, REPORT.TOTAL_BIZTYPE_SEND.id]
  }];
  /* 多消息时，需要添加该报表 */
  extraReport = REPORT.RATIO_MSG_SEND.id;


  /* 通过接口获取后端有哪些消息类型插件jar包的存在 */
  private requestMsgPluginCollection() {
    this.$request = new Subject();
    if(!this._isArray(this.MSGPLUGINS)) {
      this.http.get(URLS.msgTypes.url).subscribe(data => {
        this.MSGPLUGINS = [];
        if (data.status !== 0) {
          this.MSGPLUGINS = _MSGTYPES.getMsgList();
        } else if(this._isArray(data.data)) {
          data.data.forEach(item => {
            const configItem = _MSGTYPES.getMsgByType(false, item.index);
            this.MSGPLUGINS.push(configItem);
          })
        }
        this.$request.complete()
      }, () => {
        this.MSGPLUGINS = _MSGTYPES.getMsgList();
        this.$request.complete()
      });
    } else {
      this.$request.complete();
    }
  }

  private getMsgList(msgList?:Array<MsgItem>) {
    return this._isArray(msgList) ? msgList : deepCopy(_MSGTYPES.getMsgList())
  }

  private _isArray(list):boolean {
    return list instanceof Array;
  }

  /* 遍历消息类型*/
  private _forEach(callback, msgList?:Array<MsgItem>) {
    const tempList = this.getMsgList(msgList);
    tempList.forEach(msgItem => {
      if('function' === typeof callback) {
        callback(msgItem);
      }
    })
  }

  /**
   * 基于消息类型集合，筛选出有权限的消息类型
   * @param prefix 权限前缀
   */
   private getMsgListByPermission(prefix, msgList?:Array<MsgItem>) {
    const result = [];
    if(!prefix) return result;
    if(!prefix.endsWith('.')) prefix += '.';
    this._forEach(item => {
      const msgPermissionStr = prefix + item.key;
      if (this.aclService.canAbility(msgPermissionStr)) {
        result.push(item);
      }
    }, msgList);
    return result;
  }

  /**
   * 基于消息类型集合，筛选出后端有插件的消息类型
   * @param msgList 消息类型集合
   */
  private getMsgListByPlugin(msgList?:Array<MsgItem>) {
    const result = [];
    if(!this._isArray(msgList)) msgList = this.getMsgList(msgList);
    msgList.forEach(item => {
      for(let i = 0, len = this.MSGPLUGINS.length; i < len; i++) {
        if(item.type === this.MSGPLUGINS[i].type) {
          result.push(this.MSGPLUGINS[i]);
          break;
        }
      }
    })
    return result;
  }

  /**
   * 基于消息类型集合，筛选出有权限且有消息类型插件的消息类型
   * @param prefix 权限前缀, 为空或不填则不筛选权限
   */
  msgTypeFilter(callback:Function, prefix?:string) {
    this.requestMsgPluginCollection();
    this.$request.subscribe({
      complete: () => {
        const permissionMsgTypes = prefix ? this.getMsgListByPermission(prefix) : null;
        const result = this.getMsgListByPlugin(permissionMsgTypes);

        if('function' === typeof callback) {
          callback(result)
        }
      }
    })
  }

  /**
   * 基于消息类型集合，筛选哪些贴片类型需要展示
   */
  getMsgPatchTypeByPlugin(callback) {
    const patchTypes = deepCopy(PATCHTYPES);
    let typeStr = '';
    const result = [];

    this.requestMsgPluginCollection();
    this.$request.subscribe({
      complete: () => {
        this._forEach(msgItem => {
          typeStr += typeStr ? (',' + msgItem.patchTypes) : msgItem.patchTypes;
        }, this.MSGPLUGINS)
        patchTypes.forEach(item => {
          if(-1 !== typeStr.indexOf(item.value)){
            result.push(item)
          }
        })
        if('function' === typeof callback) {
          callback(result)
        }
      }
    })
  }

  /**
   * 基于消息类型集合，筛选哪些报表需要展示
   */
  getReportIdsByPlugin(callback) {
    let result = [];
    this.requestMsgPluginCollection();
    this.$request.subscribe({
      complete: () => {
        if(this.MSGPLUGINS && this.MSGPLUGINS.length > 1) {
          result.push(this.extraReport);
        }
        this._forEach(msgItem => {
          for(let i = 0, len = this.matchRules.length; i < len; i++) {
            if(this.matchRules[i].msgType === msgItem.type) {
              result = result.concat(this.matchRules[i].reports);
              break;
            }
          }
        }, this.MSGPLUGINS);
        if('function' === typeof callback) {
          result = [...new Set(result)];
          callback(result)
        }
      }
    })
  }
}
